import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    exclusiveOutisdeKeys,
    getDateEndFromWeekNum2,
    myAxios,
    outsideEotDefaultEmptyData,
    standbyWeeks,
    weeknum,
    MyDate,
} from "src/components/common/functions";

const allowedSearchKeys = ["category", "status", "q", "page", "limit"] as const;

export async function allEmergencyOTLoader({ params, request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if (!allowedSearchKeys.includes(key as typeof allowedSearchKeys[number])) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.has("category")) {
        url.searchParams.set("category", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("status")) {
        url.searchParams.set("status", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("q")) {
        url.searchParams.set("q", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "50");
        shouldRedirect = true;
    }

    const fallbackWeek = weeknum(new MyDate().s());
    const selectedWeek = params.week && standbyWeeks.includes(params.week) ? params.week : fallbackWeek;
    if (params.week !== selectedWeek || shouldRedirect) {
        throw redirect(`/AllEmergencyOT/${selectedWeek}?${url.searchParams.toString()}`);
    }

    const formData = new FormData();
    formData.append("week", selectedWeek);
    const res = await myAxios({ fileName: "outside/eot/allEot.php", formData });
    if (!res) throw redirect("/");

    const forms = (res.data ?? []).map((personData: Record<string, string>) =>
        Object.fromEntries(
            Object.entries(personData).map(([key, value]) =>
                !exclusiveOutisdeKeys.includes(key)
                    ? [key, JSON.parse(value || outsideEotDefaultEmptyData)]
                    : [key, value]
            )
        )
    );

    return {
        forms,
        week: selectedWeek,
        weekEnd: getDateEndFromWeekNum2(selectedWeek),
    };
}

export async function unlockEmergencyOTAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    const redirectTo = String(formData.get("redirectTo") ?? "/AllEmergencyOT");
    const res = await myAxios({
        fileName: "outside/eot/setEOTUnlock.php",
        formData,
    });
    if (!res) return null;
    throw redirect(redirectTo);
}
